import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import bootslideOption from 'scoreboard/components/bootslide/option.hbs'
import diagnostics from 'scoreboard/components/diagnostics'
import i18n from 'scoreboard/components/i18n'
import HistoryInfo from 'scoreboard/components/history-info'
import SendToOptions from 'scoreboard/components/send-to-options'
import bookmarkSlideOption from './bookmark-slide-option.hbs'
import BookmarkToggler from 'scoreboard/bookmarks/bookmark-toggler'
import permissions from 'scoreboard/components/permissions'
import PublishAlertForm from 'scoreboard/alerts/publish-subscribers-form'
import alertHelper from 'scoreboard/alerts/alert-helper'
import alertMetadata from 'scoreboard/alerts/alert-metadata'
import Briefing from './briefing'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import displayedPeriodId from 'scoreboard/components/displayed-period-id'
import user from 'scoreboard/components/user'

var BriefingOptionsMenu = BootslideMenu.extend({

	className: 'briefing-options-menu',

	/**
	 * @property {Briefing} model
	 * @param {Number} [options.width=190]
	 */
	initialize: function (options = {}) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.width = _.get(options, 'width', 240)
		this.subscriptions = this.model.get('subscriptions')
	},

	menu: function () {
		const target = _.concat([],
			this.createInfoOption(),
			this.createBookmarkOption(),
			this.createAlertOption(),
			this.createHistoryOption(),
			this.createSendToOption())

		return {
			width: this.width,
			label: i18n.get('common.options'),
			target
		}
	},

	createBookmarkOption() {
		const {id, label} = this.model.attributes
		return !user.isStrictViewer() && permissions.bookmarks() ? {
			contentView: BookmarkToggler.extend({
				iconLabel: 'bookmarks.toggle',
				url: `briefings/${id}`,
				label,
				template: bookmarkSlideOption
			})
		} : []
	},

	createAlertOption() {
		if (user.isStrictViewer() || !permissions.bookmarks()) {
			return []
		}

		const alertLabel = this.createAlertLabel()
		return {
			label: alertLabel.label,
			content: _.constant(bootslideOption({
				icon: 'warn',
				label: alertLabel.label,
				extraHtml: alertLabel.countBadge
			})),
			target: this.onAlertPublishFormChange.bind(this)
		}

	},

	createHistoryOption() {
		const {label} = this.model.attributes
		return {
			label: 'common.audit',
			content: _.constant(bootslideOption({
				icon: 'clock',
				label: 'common.audit'
			})),
			target: e => {
				e.preventDefault()
				HistoryInfo.display(this.model, label)
			}
		}
	},

	createInfoOption: function() {
		return {
			label: 'common.info',
			content: _.constant(bootslideOption({
				icon: 'info',
				label: 'common.info'
			})),
			target: e => {
				e.preventDefault()
				var briefing = new Briefing({ id: this.model.id })
				let data = {
					relatedItems : true,
					calendarPeriodId: displayedPeriodId()
				}

				appDisplay.dialog(briefing.fetch({ data }),
					() => new GenericOverviewInfo({ model: briefing }))
			}
		}
	},

	createSendToOption() {
		let sendToTargets = []
		if (diagnostics.exportEnabled && !user.isStrictViewer()) {
			let options = { uiState: this.options.uiState }
			sendToTargets = [
				{
					label: 'common.export.printer',
					contentView: SendToOptions.printAllSlides(options)[0]
				},
				{
					label: 'common.email',
					contentView: SendToOptions.emailAllSlides(options)[0]
				},
				{
					label: 'common.export.word',
					contentView: SendToOptions.wordAllSlides(options)[0]
				},
				{
					label: 'common.export.powerpoint',
					contentView: SendToOptions.pptxAllSlides(options)[0]
				},
				{
					label: 'common.export.pdf',
					contentView: SendToOptions.pdfAllSlides(options)[0]
				}
			]
		}
		if (!_.isEmpty(sendToTargets)) {
			var sendToMenu = {
				label: 'common.sendto',
				content: _.constant(bootslideOption({ icon: 'send-to', label: 'common.sendto' })),
				target: sendToTargets,
				width: this.width
			}
			return sendToMenu
		}
		return []
	},

	onAlertPublishFormChange(e) {
		e.preventDefault()
		const {organizationId, section} = this.model.attributes
		const alertForm = new PublishAlertForm({
			domainId: this.model.id,
			orgId: organizationId,
			section,
			subscriptions: this.subscriptions
		})
		appDisplay.dialog(alertForm)
		alertForm.on('done', subscriptions => {
			// Update status of alert button (only) after adding/removing a subscription
			if (subscriptions) {
				if (!this.subscriptions) {
					// Subscriptions are already persisted, but set them on the model
					// incase the user views them again before a reload (#24533)
					// (This is a bootslide menu and is destroyed, thus losing state in this.subscriptions)
					this.model.set('subscriptions', subscriptions)
				}
				this.subscriptions = subscriptions
				this.createAlertLabel()
			}
		})
	},

	createAlertLabel() {
		const {organizationId} = this.model.attributes
		const subscribed = alertHelper.userSubscribed(this.subscriptions, alertMetadata.types.CHANGE_PUBLISHED)
		const actionLabel = i18n.get(subscribed ? `common.unsubscribe` : `common.subscribe`)
		const count = _.size(this.subscriptions)
		const countBadge = count > 0 ? `<span class="alert-bubble">${count}</span>` : ''
		let label = actionLabel
		if (permissions.briefings(organizationId)) {
			label = _.escape(i18n.get('alerts.publishOr', actionLabel))
		}
		this.$el.toggleClass('is-subscribed', subscribed)
		return { label, countBadge }
	}
})

export default BriefingOptionsMenu

BriefingOptionsMenu.__filename__ = 'briefings/briefing-options-menu.js'
